export default __webpack_public_path__ + "static/media/flash10.ce3b2d7a.png";